var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',[_c('q-img',{attrs:{"height":"100vh","src":"/dashboard/images/bg_login.jpg"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }